/*
 * @Author: 姚阳子 yaoyangzi@linhuiba.com
 * @Date: 2023-05-12 16:12:11
 * @LastEditors: 姚阳子 yaoyangzi@linhuiba.com
 * @LastEditTime: 2023-05-12 16:12:19
 * @FilePath: /locationpms-pc/src/config.ts
 * @Description: wkcrm config
 *
 *
 */
var getLocationOrigin = function () {
    return window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
};
var macUrl = 'https://www.5kcrm.com/download/desktop/mac/%E6%82%9F%E7%A9%BACRM.dmg';
var winUrl = 'https://www.5kcrm.com/download/desktop/win/%E6%82%9F%E7%A9%BACRM.exe';
var iOSUrl = 'https://apps.apple.com/cn/app/%E6%82%9F%E7%A9%BAcrm-10-0/id1489143707';
var androidUrl = 'https://sj.qq.com/myapp/detail.htm?apkName=com.kakarote.crm10';
var registerUrl = 'https://www.72crm.com/72crm/#/register/index';
var loginUrl = 'https://www.72crm.com/72crm/#/';
var contactUrl = 'https://www.72crm.com/contact'; // 联系我们
var companyName = '悟空CRM';
var version = 'V12.0.0';
var baiduKey = 'lcuOQ71SCZhqpxsr1vL2mXoplWEoVctL';
var build = 20220110;
// 默认表格样式
var tableStyle = {
    stripe: true,
    class: [] // 'is-right-border-style', 'is-bottom-border-style'
};
export default {
    version: version,
    build: build,
    companyName: companyName,
    getLocationOrigin: getLocationOrigin,
    baiduKey: baiduKey,
    macUrl: macUrl,
    winUrl: winUrl,
    iOSUrl: iOSUrl,
    androidUrl: androidUrl,
    registerUrl: registerUrl,
    tableStyle: tableStyle,
    loginUrl: loginUrl,
    contactUrl: contactUrl
};
